import { HttpClient } from '@angular/common/http';
import { AfterViewInit, Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { AdminapiService } from 'src/app/shared/services/adminapi.service';
import { ADTSettings  } from 'angular-datatables/src/models/settings';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { BasicActionsEventType } from '../DatatableEvents/basic-actions-event-type';
import { UserActionsComponent } from '../DatatableEvents/user-actions.component';
import { WebapiService } from 'src/app/shared/services/webapi.service';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/store/app.states';
import { UserInfo } from 'src/app/store/actions/user.action';
class DataTablesResponse {
  data: any[];
  recordsFiltered: number;
  recordsTotal: number;
}
declare var $: any;
declare var bootstrap: any;

@Component({
  selector: 'app-admin-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.scss']
})
export class UsersComponent implements OnInit {
  @ViewChild(DataTableDirective, {static: false})
  dtElement: DataTableDirective;
  @ViewChild('basicActions') basicActions: TemplateRef<UserActionsComponent>;
  dtTrigger: Subject<ADTSettings> = new Subject<ADTSettings>();
  //dtOptions: DataTables.Settings = {};
  dtOptions: ADTSettings = {};
  message = '';
  editUser=null;
  modalid="newuer"
  modalid1="deletecommon"
  modalid2="addusermodal"
  deleteid=""
  constructor(public adminApi: AdminapiService,public webApi: WebapiService,private store: Store<AppState>){


  }

  
  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      // Destroy the table first
      $('table.dataTable').DataTable().clearPipeline().draw();
      //dtInstance.clearPipeline().draw()
      //dtInstance.clear().draw();
      dtInstance.destroy();
      // Call the dtTrigger to rerender again
      this.dtTrigger.next(this.dtOptions);
    });
  }

  changeData(event){
    this.rerender()
  }

  ngOnInit(): void {
    setTimeout(() => {
      const self = this;
      this.dtOptions = {
        serverSide: true,  
        ordering:false,
        processing: true,
        language: {
          searchPlaceholder: "Search name, email, role...",
          // search: "Search:",
        },
        lengthMenu:['10','20','30','40','50'],
        //order: [[0, 'desc']],
        //columnDefs: [{ targets: 3, orderable: false }],
        pageLength: 50,   // Set the flag 
        ajax: this.adminApi.getUsers(),
        columns: [{
          title: 'ID',
          data: 'id'
        }, {
          title: 'Name',
          data: 'name'
        }, {
          title: 'Email',
          data: 'email'
        }, {
          title: 'Role',
          data: 'role'
        }, {
          title: 'Label',
          data: 'label'
        },{
          title: 'Status',
          data: 'status'
        },
        {
          title: 'Actions',
          data: null,
          ngTemplateRef: {
            ref: this.basicActions,
            context: {
              // needed for capturing events inside <ng-template>
              captureEvents: self.onCaptureEvent.bind(self),
            }
          }
        
        }
      ]
      };
    });
  }

  ngAfterViewInit() {
    setTimeout(() => {
      // race condition fails unit tests if dtOptions isn't sent with dtTrigger
      this.dtTrigger.next(this.dtOptions);
    }, 200);
  }

  loginas(id){
    let params={id:id}
    this.adminApi.loginas(params).subscribe((data: any) => {
      if(data && data.success==1){
        this.store.dispatch(new UserInfo())
          this.webApi.setLoader(true)
          this.webApi.setSession(data);
          window.open("/")
        }
    });
  }


  onCaptureEvent(event: BasicActionsEventType) {
    //this.message = `Event '${event.cmd}' with data '${JSON.stringify(event.data)}`;
    if(event.cmd=='edit'){
      this.editUser = event.data;
      this.openModal()
    }
    if(event.cmd=='edit_manual'){
      this.editUser = event.data;
      this.openModalAdd()
    }
    if(event.cmd=='delete'){
      this.deleteid = event.data.id;
      this.openConfirmModal()
    }
    if(event.cmd=='login'){
      event.data.id;
      this.loginas(event.data.id)
    }
    if(event.cmd=='view'){
      console.log("userid",event.data.id);
    }
  }

  ngOnDestroy(): void {
    // Do not forget to unsubscribe the event
    this.dtTrigger.unsubscribe();
  }

  addNewModal() {
    this.editUser = null;

    this.openModalAdd()
  }

  
  openModalAdd(){
    setTimeout(()=>{
      if(document.getElementById(this.modalid2)){
        var myModal = new bootstrap.Modal(document.getElementById(this.modalid2), {
          keyboard: true
        })
        myModal.show()
      }
    },300)
  }

  openModal(){
    setTimeout(()=>{
      if(document.getElementById(this.modalid)){
        var myModal = new bootstrap.Modal(document.getElementById(this.modalid), {
          keyboard: true
        })
        myModal.show()
      }
    },300)
  }
  openConfirmModal(){
    setTimeout(()=>{
      if(document.getElementById(this.modalid1)){
        var myModal = new bootstrap.Modal(document.getElementById(this.modalid1), {
          keyboard: true
        })
        myModal.show()
      }
    },300)
  }
}
